import React from 'react';

import ContentLoader from '@components/ContentLoader';
import DesktopHeader from '@components/DesktopHeader';
import { RoleGuard } from '@components/Guards';
import SideStripDesktop from '@components/SideStripDesktop';

import { RoleName } from '@constants/role_name';

import { AppContent } from './AppLayout.style';

const ADMIN_SETTINGS = [
  [
    'home',
    // 'addAccount',
    'adminManagement',
    'appInformation',
  ],
] as const;

const AdminLayout: React.FC<{
  friendlyName?: string | null;
  children: React.ReactNode;
  loading?: boolean;
  mobile?: boolean;
}> = ({ friendlyName, children = null, loading = false }) => {
  return (
    <RoleGuard roles={[RoleName.Admin]}>
      <SideStripDesktop isAdmin settings={ADMIN_SETTINGS} />
      <DesktopHeader friendlyName={friendlyName} />
      <AppContent>
        <ContentLoader loading={loading}>{children}</ContentLoader>
      </AppContent>
    </RoleGuard>
  );
};

export default AdminLayout;
